import React from "react";

export default function DebtMoreFilters({ register, setValue, filterData }) {
  return (
    <>
      <div className="col half_flex_form">
        <div className="form_blk range_slide">
          <div className="info_lbl_lbl">
            <h6>Mortgage Amount</h6>
          </div>
          {/* <MultiRangeSlider
                                        name="mortgage_amount"
                                        defaultMin={
                                          multSelectOptions
                                            ?.mortgage_amount?.length > 0
                                            ? multSelectOptions
                                                ?.mortgage_amount[0]
                                            : 0
                                        }
                                        defaultMax={
                                          multSelectOptions
                                            ?.mortgage_amount?.length > 0
                                            ? isNaN(
                                                multSelectOptions
                                                  ?.mortgage_amount[1]
                                              )
                                              ? 100000000
                                              : multSelectOptions
                                                  ?.mortgage_amount[1]
                                            : 100000000
                                        }
                                        min={0}
                                        max={100000000}
                                        onChange={({ min, max }) =>
                                          handleMultiSelectChange(
                                            "mortgage_amount",
                                            min,
                                            max
                                          )
                                        }
                                        is_mortgage_amount={true}
                                      /> */}
        </div>
      </div>

      <div className="col half_flex_form">
        <div className="form_blk">
          <div className="info_lbl_lbl">
            <h6>Mortgage origination</h6>
          </div>
          <div className="boolean_flex">
            {[
              {
                value: "last_year",
                label: "Last year",
              },
              {
                value: "1_2_year",
                label: "Last 1-2 years",
              },
              {
                value: "2_3_year",
                label: "Last 2-3 years",
              },
              {
                value: "3_5_year",
                label: "Last 3-5 years",
              },
              {
                value: "5_7_year",
                label: "Last 5-7 years",
              },
              {
                value: "7_8_year",
                label: "Last 7-8 years",
              },
              {
                value: "8_10_year",
                label: "Last 8-10 years",
              },
              {
                value: "10_12_year",
                label: "Last 10-12 years",
              },
              {
                value: "12_14_year",
                label: "Last 12-14 years",
              },
              {
                value: "14_16_year",
                label: "Last 14-16 years",
              },
              {
                value: "16_18_year",
                label: "Last 16-18 years",
              },
              {
                value: "18_20_year",
                label: "Last 18-20 years",
              },
            ].map((option) => (
              <div className="lbl_btn" key={option.value}>
                <input
                  type="radio"
                  name="mortage_origination"
                  value={option.value}
                  id={option.value}
                  className="hidden"
                  {...register("mortage_origination")}
                  defaultChecked={
                    filterData?.mortage_origination === option.value
                  }
                />
                <label
                  htmlFor={option.value}
                  onClick={() => setValue("mortage_origination", option.value)}
                  className={`site_btn blank yellow_blank main_color ${
                    filterData?.mortage_origination === option.value
                      ? "active"
                      : ""
                  }`}
                >
                  <span>{option.label}</span>
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
